<template>
  <div style="display: inline-block; vertical-align: super">
    <!-- 基础提示框组件 -->
    <el-tooltip :popper-options="{ html: true }" placement="top" effect="dark" popper-class="custom-tooltip-popper">
      <div slot="content" style="font-size: 14px; max-width: 600px">
        <!-- {{ text }} -->
        <div v-safe-html="text"></div>
      </div>
      <!-- <i class="el-icon-question" style="font-size: 15px;"></i> -->
      <!-- 信息按钮 -->
      <i class="el-icon-info"></i>

      <!-- <el-button type="text" icon="el-icon-info" size="medium" style="padding: 0"></el-button> -->
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "InfoTooltip",
  props: {
    // 提示文本内容
    text: {
      // type: String,
      // required: true,
      default: "",
    },
  },
};
</script>

<style>
.el-tooltip__popper p {
  color: var(--light-gary2); /* 强制文本为白色 */
  line-height: 1.6; /* 可选：优化行高，提升可读性 */
  font-size: 14px; /* 可选：统一文本字号 */
}
.el-icon-info {
  font-size: 18px;
  color: #ccc !important;
}
</style>
